import { faro, PushErrorOptions, PushLogOptions } from '@grafana/faro-react';

interface Logger {
  // can be filtered in Grafana by `kind=exception`
  exception: (error: Error, options?: PushErrorOptions) => void;
  // can be filtered in Grafana by `kind=log`
  log: (log: string, options?: PushLogOptions) => void;
}

export function getLogger(): Logger {
  // if faro not initialised
  if (!faro.api) {
    return {
      exception() {
        return null;
      },
      log() {
        return null;
      },
    };
  }

  return {
    exception(error, options) {
      faro.api.pushError(error, options);
    },
    log(log, options) {
      faro.api.pushLog([log], options);
    },
  };
}
